import { useCanPrepareOnBehalf } from '@features/user';

import { useConnectedPrescribers } from './useConnectedPrescribers';

/**
 * GDN-1119: shared proxy → prescriber resolution for every "open DoseSpot
 * for a patient" surface (encounter CTA, patient card, setup card).
 *
 * `isProxy` is the effective prepare-on-behalf capability from user-info
 * (per-person flag AND the operations_support role) — the same authority the
 * backend's SSO proxy check uses. It is no longer a role.
 */
export function useProxyOnBehalfOf() {
  const isProxy = useCanPrepareOnBehalf();
  const { prescribers, isLoading } = useConnectedPrescribers({
    skip: !isProxy,
  });
  return { isProxy, prescribers, isLoading };
}
